"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var React = tslib_1.__importStar(require("react"));

exports.EFFECT_ID = Symbol('react-async');

var AsyncAssetManager =
/** @class */
function () {
  function AsyncAssetManager() {
    var _this = this;

    this.used = new Set();
    this.effect = {
      id: exports.EFFECT_ID,
      betweenEachPass: function betweenEachPass() {
        _this.used.clear();
      }
    };
  }

  AsyncAssetManager.prototype.markAsUsed = function (id) {
    this.used.add(id);
  };

  return AsyncAssetManager;
}();

exports.AsyncAssetManager = AsyncAssetManager;
exports.AsyncAssetContext = React.createContext(undefined);